import { render, staticRenderFns } from "./FavoriteComponent.vue?vue&type=template&id=54e1cc74&scoped=true"
import script from "./FavoriteComponent.vue?vue&type=script&lang=js"
export * from "./FavoriteComponent.vue?vue&type=script&lang=js"
import style0 from "./FavoriteComponent.vue?vue&type=style&index=0&id=54e1cc74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e1cc74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e1cc74')) {
      api.createRecord('54e1cc74', component.options)
    } else {
      api.reload('54e1cc74', component.options)
    }
    module.hot.accept("./FavoriteComponent.vue?vue&type=template&id=54e1cc74&scoped=true", function () {
      api.rerender('54e1cc74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/FavoriteComponent.vue"
export default component.exports